module.exports = __webpack_public_path__ + "static/event4-5dc68762f25d2b0a6069e02a2290cec8.jpeg";